export default __webpack_public_path__ + "static/Finances-ClassicFinance-624x176~xAHajLRZ-c8ffc52dd9026bc2c5bf7425a4215b73.png";